export default "__VITE_ASSET__EgvbI7KL__"